// import React from "react";
import { useState } from "react";
import InnerHero from "../components/InnerHero";
import productsData from "../data/products";
import ProductModal from "../components/ProductCard";
import UsageSafety from "../components/UsageSafety";
import CTASection from "../components/CTASection";

function Fungicide() {
    const [selectedProduct, setSelectedProduct] = useState(null);

    // 🔹 SIRF INSECTICIDE PRODUCTS
    const insecticideProducts = productsData.filter(
        product => product.category === "Fungicide"
    );
    return (
        <>
            <InnerHero
                title="Fungicides"
                subtitle="Advanced disease control solutions to protect crops from fungal infections and improve overall plant health."
                breadcrumb="Home / Products"
                bgImage="/images/img/fung.jpg"
            />

            <section className="category-intro-section">
                <div className="container">
                    <div className="row align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="category-intro-content">
                                <h6 className="section-subtitle">CATEGORY OVERVIEW</h6>
                                <h2>
                                    Effective <span>Fungal Disease Control</span> for Stronger Crops
                                </h2>

                                <p>
                                    Fungal diseases are a major threat to crop health, affecting
                                    plant growth, yield quality, and overall farm productivity.
                                    Timely and effective disease management is essential to
                                    maintain healthy crops throughout the growing cycle.
                                </p>

                                <p>
                                    Goodweel Crop Care offers a comprehensive range of fungicides
                                    developed to provide both preventive and curative protection
                                    against a wide spectrum of fungal infections. Our products are
                                    formulated using advanced chemistry and tested under real
                                    Indian field conditions.
                                </p>

                                <p>
                                    With consistent performance, crop safety, and ease of
                                    application, our fungicides help farmers achieve disease-free
                                    growth, improved yield quality, and long-term crop strength.
                                </p>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="col-lg-6">
                            <div className="category-intro-image">
                                <img
                                    src="/images/img/16.jpg"
                                    alt="Fungicides Crop Protection"
                                    className="img-fluid"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* SECTION HEADING */}
            <div className="container text-center my-5">
                <h2 className="section-title">
                    Our <span>Fungicide Products</span>
                </h2>
                <p className="section-desc">
                    Explore our range of high-performance fungicides developed
                    to prevent and control fungal diseases under diverse
                    agricultural conditions.
                </p>
            </div>

            {/* PRODUCTS GRID (CSS SAME AS PRODUCT PAGE) */}
            <div className="container">
                <div className="row">
                    {insecticideProducts.map(product => (
                        <div
                            className="col-lg-3 col-md-4 col-sm-6 mb-4 Product-col"
                            key={product.id}
                        >
                            <div
                                className="product-card"
                                onClick={() => setSelectedProduct(product)}
                            >
                                <img
                                    src={product.image}
                                    alt={product.name}
                                />
                                <div className="product-overlay">
                                    <h6>{product.name}</h6>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* SAFETY CHECK */}
                    {insecticideProducts.length === 0 && (
                        <p className="text-center mt-4">
                            No Fungicide products available at the moment.
                        </p>
                    )}
                </div>
            </div>

            {/* PRODUCT DETAILS MODAL (UNCHANGED) */}
            {selectedProduct && (
                <ProductModal
                    product={selectedProduct}
                    close={() => setSelectedProduct(null)}
                />
            )}
            <UsageSafety />            
            <CTASection />

        </>
    );
};

export default Fungicide;
